import { render, staticRenderFns } from "./GuangzhouUnicom1.vue?vue&type=template&id=10df30cc&scoped=true"
import script from "./GuangzhouUnicom1.vue?vue&type=script&lang=js"
export * from "./GuangzhouUnicom1.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouUnicom1.vue?vue&type=style&index=0&id=10df30cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df30cc",
  null
  
)

export default component.exports